import { useContext } from 'react';
import { tAccIdContext } from './context';

export const useTAccId = () => {
  const handlers = useContext(tAccIdContext);
  return handlers;
};
